import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SortOption, SortOptionValue, ASSOCIATED_CRM_OBJECT_CONFIG } from '../constants';

@Component({
  selector: 'automata-get-associated-crm-object-panel',
  templateUrl: './get-associated-crm-object-panel.component.html',
  styleUrls: ['./get-associated-crm-object-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class GetAssociatedCrmObjectPanelComponent extends CommonActionPanelComponent implements OnInit {
  options: SortOption[] = [];
  optionsFormControl: FormControl<SortOptionValue> = new FormControl<SortOptionValue>(null, Validators.required);
  tipTranslationKey = '';

  ngOnInit(): void {
    super.ngOnInit();
    this.options = ASSOCIATED_CRM_OBJECT_CONFIG[this.taskDefinitionId]?.sortOptions;
    this.tipTranslationKey = ASSOCIATED_CRM_OBJECT_CONFIG[this.taskDefinitionId]?.automationPanelTip;

    if (this.step?.data) {
      const jsonData = JSON.parse(this.step.data);
      const value = { id: jsonData.sort_field, direction: jsonData.sort_direction };
      this.optionsFormControl.setValue(value);
    } else {
      this.optionsFormControl.setValue(this.options[0].value);
    }
    this.savingEnabled = true;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    const jsonData = this.step?.data ? JSON.parse(this.step.data) : {};
    const selectedOption = this.optionsFormControl.value;
    jsonData.sort_field = selectedOption.id;
    jsonData.sort_direction = selectedOption.direction;
    return jsonData;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.optionsFormControl];
  }

  isFormValid(): boolean {
    return !this.optionsFormControl.invalid;
  }

  compareOptions(s1: SortOptionValue, s2: SortOptionValue): boolean {
    return s1?.id === s2?.id && s1?.direction === s2?.direction;
  }
}
